// removed by extract-text-webpack-plugin
module.exports = {"badge":"Badge-m__badge___30mIm","badgeWrapper":"Badge-m__badgeWrapper___3uwx7","badgeLabel":"Badge-m__badgeLabel___2m7M4"};


//////////////////
// WEBPACK FOOTER
// ./components/badge/Badge.m.sass
// module id = 6Tqr
// module chunks = 0